import React from "react"
import { useTranslation } from "react-i18next"
import { H2 } from "./Styling"
import Photo from "./Photo"
import PhotoContent from "./PhotoContent"

const About = () => {
  const [t] = useTranslation("global")

  return (
    <div id="about" className="bg-gray-100 pt-16 sm:pt-24 pb-24 sm:pb-32">
      <PhotoContent>
        <Photo align="left" src="/images/about.jpeg" />

        <div className="sm:w-1/2 text-gray-600 pl-4 pr-4 sm:pr-16">
          <H2>{t("about.header")}</H2>

          <p className="mt-4">
            {t("about.1-1")}
            <a
              className="text-primary"
              href="https://www.linkedin.com/in/jsteterissa"
              target="_blank"
              rel="noreferrer"
            >
              Jordi{" "}
            </a>
            {t("about.1-2")}
            <a
              className="text-primary"
              href="https://www.linkedin.com/in/richard-van-der-veen"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Richard,{" "}
            </a>
            {t("about.1-3")}
          </p>
          <p className="mt-4">{t("about.2")}</p>
          <p className="mt-4">
            {t("about.3-1")}
            <a
              className="text-primary"
              href="https://maps.app.goo.gl/rQHyEwnPxRT7yU6g6"
              target="_blank"
              rel="noreferrer"
            >
              Rotterdam
            </a>
            {t("about.3-2")}
            <a
              className="text-primary"
              href="/contact"
              target="_self"
              rel="noreferrer"
            >
              contact
            </a>
            {t("about.3-3")}
          </p>
        </div>
      </PhotoContent>
    </div>
  )
}

export default About
